import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const fetchActiveVehicleSystems = () => {
  return apiActionCreator({
    'endpoint': '/bulletin/vehicle-systems',
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_ACTIVE_VEHICLE_SYSTEMS,
      ActionTypes.FETCHED_ACTIVE_VEHICLE_SYSTEMS,
      [
        ActionTypes.FETCHED_ACTIVE_VEHICLE_SYSTEMS_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};
